import { createSelector } from 'reselect';

const getAuthorizationClaimsReducer = (state) => state.authorizationClaimsReducer;

const getUserInfo = createSelector(
    [getAuthorizationClaimsReducer],
    (userInfo) => userInfo.userInfo
  );

  const getNavigatorState = createSelector(
    [getAuthorizationClaimsReducer],
    (userInfo) => userInfo.navigtorOpen
  );

  const getLogoutChecked = createSelector(
    [getAuthorizationClaimsReducer],
    (userInfo) => userInfo.isLogoutClicked
  );

  const getUserRoles = createSelector(
    [getAuthorizationClaimsReducer],
    (userInfo) => userInfo.role
  );

  const getUserPermissions= createSelector(
    [getAuthorizationClaimsReducer],
    (userInfo) => userInfo.permissions
  );

  export {
    getUserInfo,
    getNavigatorState,
    getLogoutChecked,
    getUserRoles,
    getUserPermissions
  };